/**
 * @Des 新增/编辑 账户 弹出层
 * @Auth
 * @Date 2021/6/19
 */

/* HTML */
<template>
    <div v-if="dialogForm.dialogFormVisible">
    	<el-dialog :title="dialogForm.title"
	               :visible.sync="dialogForm.dialogFormVisible"
	               :close-on-click-modal="false"
	               custom-class="form-dialog"
	               v-dialogDrag
	               class="dialog_title"
	               @close="handleDialogClose"
	    >
            <LocationTrackMap ref="locationTrackMap" v-if="!$checkEmpty(trackInfos)" :trackObj="trackObj" :trackInfos="trackInfos" :timeDiff="timeDiff" />

	    </el-dialog>
    </div>
</template>

<script>
    // // 引入基本模板
    import LocationTrackMap from "./LocationTrackMap";

    export default {
        /**
         * @Des 组件名
         * @Auth
         * @Date 2021/6/19
         */
        name: 'LocationTrackPlay',
        /**
         * @Des 数据接收类型
         * @Auth
         * @Date 2021/6/19
         */
        props:{
        },
        /**
         * @Des 组件引用
         * @Auth
         * @Date 2021/6/19
         */
        components: {
            LocationTrackMap
        },
        mounted() {
        },
        /**
         * @Des 数据定义
         * @Auth
         * @Date 2021/6/19
         */
        data() {
            return{
                /**
                 * @Des 弹出层属性
                 * @Auth
                 * @Date 2021/6/19
                 */
                dialogForm: {
                    title: "",
                    dialogFormVisible: false,
                },
                // 人员/车辆/工具
                trackObj: {},
                // 轨迹点
                trackInfos: [],
                // 时间差值ms
                timeDiff: 1000,
            }
        },
        /**
         * @Des 方法定义
         * @Auth
         * @Date 2021/6/19
         */
        methods:{
            /**
             * @Des 打开账户弹窗
             * @Auth
             * @Date 2021/6/19
             */
            openDialog(bindingType, trackObj, trackInfos, timeDiff){
                this.dialogForm.dialogFormVisible = true;
                if(bindingType == 1){
                    this.dialogForm.title =  trackObj.userName + "的轨迹播放";
                }else if(bindingType == 2){
                    this.dialogForm.title =  trackObj.carNumber + "的轨迹播放";
                    trackObj.typeId = 100;
                }else if(bindingType == 3){
                    this.dialogForm.title =  trackObj.toolName + "的轨迹播放";
                }
				
                this.trackObj = Object.assign({}, trackObj);
                this.trackInfos = Object.assign([], trackInfos);
                this.timeDiff = timeDiff;
            },

            /**
	         * @Des 关闭弹窗
	         * @Auth
	         * @Date 2021/6/19
	         */
	        handleDialogClose(){
                this.dialogForm.dialogFormVisible = false;
                this.trackObj = {};
                this.trackInfos = [];
	        },

            /**
	         * @Des 重置方法
	         * @Auth Zhangbin
	         * @Date 17:28 2021/4/30
	         */
	        reset(){
	        },


        },// methods
    }
</script>
/* JS */

/* CSS */
<style scoped>
    *{
        box-sizing: border-box;
    }

    /deep/ .el-dialog {
    	width: 90%;
    	height: calc(100% - 15vh - 50px);
    }
    .dialog_title{
        text-align: left;
        margin-top: -10vh;
    }
	/deep/ .el-dialog__body {
		height: 100%;
	}
    /*/deep/ .el-dialog__header .el-dialog__title{
        font-size: 16px;
    }

    /deep/ .el-form-item__label{
        font-size: 14px;
    }
    /deep/ .el-dialog__body{
        height: 100%;
        padding: 20px;
        position: relative;
    }
    /deep/ .el-form-item{
        margin-bottom: 20px;
    }
    /deep/ .el-form-item:last-child{
        margin-bottom: 15px;
    }

    /deep/ .el-form-item__content {
    	max-width:300px;
    }
    /deep/ .el-input {
    	width: 100% !important;
    }

    /deep/ .numberScreening {
    	border-color: #DCDFE6;
    }
    /deep/ .aaa {
    	border-bottom-color: #DCDFE6;
    }*/

    /*========= form 上下结构 start =========*/
    /*========= 头像 start =========*/
    .image-form-item {
	    width: 120px;
	    position: absolute;
	    right: 20px;
	    top: 20px;
	    /*padding-top: 25px;*/

	   color: #e6e6e6;
    }
    .image-item-title {
        width: 100%;
    	display: block;
    	line-height: 20px;
    	text-align: center;
    	margin-top: 5px;
    	background: #3f51b5;
    	color: #e6e6e6;
    }
    button.image-item-title {
    	cursor: pointer;
    	border: none;

    	transition: all 0.4s;
    }
    button.image-item-title:hover {
    	background-color: #222285;
    	color: #ffffff;
    }
    .image-item-box {
    	width: 100%;
    	height: 120px;
    	border: 1px solid #DCDFE6;
	    border-radius: 4px;

	    text-align: center;
	    line-height: 118px;
	    /*cursor: pointer;*/
	    position: relative;

	    transition: all 0.4s;
    }
    .image-item-box:hover {
    	border-color: #ffffff;
    	background-color: #222285;
    }
    .image-item-box img {
    	height: auto;
    	width: auto;
    	max-height: 110px;
    	max-width: 110px;
    	display: block;

    	margin: auto;
	    position: absolute;
	    top: 0;
	    bottom: 0;
	    left: 0;
	    right: 0;
    }
    .image-item-box .noImgItem {
    	font-size: 60px;
		display: none;
		line-height: 2;

		margin: auto;
	    position: absolute;
	    top: 0;
	    bottom: 0;
	    left: 0;
	    right: 0;
    }

    .image-item-box.none-item img {
    	display: none;
    }
    .image-item-box.none-item .noImgItem {
    	display: block;
    }

    .camara-pre-view {
    	display: none;
    }
    .camara-pre-view.on {
    	display: block;
    }
    /*========= 头像 end =========*/

    /deep/ .el-form-item__label {
    	line-height: 20px;
        z-index: 1;
		position: relative;
    }
    .el-form-item {
    	float: left;
    	margin-bottom: 15px;
    }
    .row-items-1 {
    	width: calc((100% - 120px));
    }
    .row-items-2 {
    	width: calc((100% - 120px) / 2);
    }
    .row-items-3 {
    	width: calc((100% - 120px) / 3);
    }
    /deep/ .el-form-item__content {
    	max-width: calc(100% - 20px);
    }
    .el-select {
    	width: 100%;
    }
    .phone-code-select {
    	width: 80px;
    	position: absolute;
    	z-index: 1;
    }
    /deep/ .phone-item-input .el-input__inner {
    	padding-left: 95px;
    }
    /*========= form 上下结构 end =========*/

    /deep/ .rt-input .el-input__inner{
        background-color: #adaaaa;
        color: rgb(7 8 10) !important;
        cursor: pointer;
    }

    /deep/ .rt-input .el-textarea__inner{
        background-color: #adaaaa;
        color: rgb(7 8 10) !important;
        cursor: pointer;
    }

    /deep/ .rt-input .el-input__suffix-inner{
        background-color: #adaaaa;
        color: rgb(7 8 10) !important;
        cursor: pointer;
    }

    /deep/ .el-button{
        background-color: #5f610c;
    }

    /deep/ .el-button:hover {
        background: #222285;
    }

</style>



// WEBPACK FOOTER //
// src/components_pages/Location/LocationTrackPlay.vue